// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-auto-complete {
  /* Background color */
  --perxis-auto-auto-complete-background-color-inner: var(
    --perxis-auto-auto-complete-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-auto-complete-divider-background-color-inner: var(
    --perxis-auto-auto-complete-divider-background-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  /* End Background color */
  /* Padding */
  --perxis-auto-auto-complete-input-padding-inner: var(--perxis-auto-auto-complete-input-padding, 18px);
  /* End Padding */
  /* Border */
  --perxis-auto-auto-complete-border-radius-inner: var(--perxis-auto-auto-complete-border-radius, 8px);
  --perxis-auto-auto-complete-border-color-inner: var(
    --perxis-auto-auto-complete-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-auto-complete-active-border-color-inner: var(
    --perxis-auto-auto-complete-active-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-auto-complete-filled-border-color-inner: var(
    --perxis-auto-auto-complete-filled-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-auto-complete-error-border-color-inner: var(
    --perxis-auto-auto-complete-error-border-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-auto-complete-border-inner: var(
    --perxis-auto-auto-complete-border,
    2px solid var(--perxis-auto-auto-complete-border-color-inner)
  );
  --perxis-auto-auto-complete-active-border-inner: var(
    --perxis-auto-auto-complete-active-border,
    2px solid var(--perxis-auto-auto-complete-active-border-color-inner)
  );
  --perxis-auto-auto-complete-filled-border-inner: var(
    --perxis-auto-auto-complete-filled-border,
    2px solid var(--perxis-auto-auto-complete-filled-border-color-inner)
  );
  --perxis-auto-auto-complete-error-border-inner: var(
    --perxis-auto-auto-complete-error-border,
    2px solid var(--perxis-auto-auto-complete-error-border-color-inner)
  );
  /* End Border */
  /* Colors */
  --perxis-auto-auto-complete-error-color-inner: var(
    --perxis-auto-auto-complete-error-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-auto-complete-discard-icon-color-inner: var(--perxis-auto-auto-complete-discard-icon-color, inherit);
  --perxis-auto-auto-complete-discard-hover-icon-color-inner: var(
    --perxis-auto-auto-complete-discard-hover-icon-color,
    inherit
  );
  --perxis-auto-auto-complete-search-icon-color-inner: var(--perxis-auto-auto-complete-search-icon-color, inherit);
  --perxis-auto-auto-complete-search-hover-icon-color-inner: var(
    --perxis-auto-auto-complete-search-hover-icon-color,
    inherit
  );
  /* End Colors */
  /* Sizes */
  --perxis-auto-auto-complete-height-inner: var(--perxis-auto-auto-complete-height, 46px);
  --perxis-auto-auto-complete-search-icon-size-inner: var(--perxis-auto-auto-complete-search-icon-size, 15px);
  --perxis-auto-auto-complete-discard-icon-size-inner: var(--perxis-auto-auto-complete-discard-icon-size, 15px);
  --perxis-auto-auto-complete-divider-width-inner: var(--perxis-auto-auto-complete-divider-width, 2px);
  /* End Sizes */
  width: 100%;
  background: var(--perxis-auto-auto-complete-background-color-inner);
  border-radius: var(--perxis-auto-auto-complete-border-radius-inner);
  box-sizing: border-box;
  border: var(--perxis-auto-auto-complete-border-inner);
  height: auto;
}
.perxis-auto-1_16_13-auto-complete--active {
  border: var(--perxis-auto-auto-complete-active-border-inner);
}
.perxis-auto-1_16_13-auto-complete--active .perxis-auto-1_16_13-auto-complete__dropdown {
  border-bottom-color: var(--perxis-auto-auto-complete-dropdown-active-border-color-inner);
}
.perxis-auto-1_16_13-auto-complete--filled {
  border: var(--perxis-auto-auto-complete-filled-border-inner);
}
.perxis-auto-1_16_13-auto-complete--filled .perxis-auto-1_16_13-auto-complete__dropdown {
  border-bottom-color: var(--perxis-auto-auto-complete-dropdown-filled-border-color-inner);
}
.perxis-auto-1_16_13-auto-complete--error {
  border: var(--perxis-auto-auto-complete-error-border-inner);
}
.perxis-auto-1_16_13-auto-complete__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}
.perxis-auto-1_16_13-auto-complete__error.perxis-auto-1_16_13-typography.perxis-auto-1_16_13-text {
  /* Colors */
  --perxis-auto-auto-complete-error-text-color-inner: var(
    --perxis-auto-auto-complete-error-text-color,
    var(--perxis-auto-auto-complete-error-color)
  );
  /* End Colors */
  /* Typography */
  --perxis-auto-auto-complete-error-text-line-height-inner: var(
    --perxis-auto-auto-complete-error-text-line-height,
    1
  );
  /* End Typography */
  /* Padding */
  --perxis-auto-auto-complete-error-padding-inner: var(--perxis-auto-auto-complete-error-padding, 8px 0);
  /* End Padding */
  --perxis-auto-typography-super-small-line-height-xxs: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--perxis-auto-auto-complete-error-text-line-height-inner);
  color: var(--perxis-auto-auto-complete-error-text-color-inner);
  padding: var(--perxis-auto-auto-complete-error-padding-inner);
}
.perxis-auto-1_16_13-auto-complete--dropdown-open {
  border-bottom: var(--perxis-auto-auto-complete-active-border-inner);
  border-bottom-color: var(--perxis-auto-auto-complete-border-color-inner);
  border-radius: var(--perxis-auto-auto-complete-border-radius-inner) var(--perxis-auto-auto-complete-border-radius-inner) 0 0;
}
.perxis-auto-1_16_13-auto-complete__dropdown {
  /* Colors */
  --perxis-auto-auto-complete-dropdown-color-inner: var(
    --perxis-auto-auto-complete-dropdown-color,
    var(--perxis-auto-root-second-color)
  );
  --perxis-auto-auto-complete-dropdown-background-color-inner: var(
    --perxis-auto-auto-complete-dropdown-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Option */
  --perxis-auto-auto-complete-option-color-inner: var(
    --perxis-auto-auto-complete-option-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-auto-complete-option-active-color-inner: var(
    --perxis-auto-auto-complete-option-active-color,
    var(--perxis-auto-auto-complete-option-color-inner)
  );
  --perxis-auto-auto-complete-option-padding-inner: var(--perxis-auto-auto-complete-option-padding, 12px 16px);
  --perxis-auto-auto-complete-option-font-family-inner: var(
    --perxis-auto-auto-complete-option-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-auto-complete-option-font-variant-numeric-inner: var(
    --perxis-auto-auto-complete-option-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-auto-complete-option-font-size-inner: var(--perxis-auto-auto-complete-option-font-size, 14px);
  --perxis-auto-auto-complete-option-font-weight-inner: var(--perxis-auto-auto-complete-option-font-weight, 400);
  --perxis-auto-auto-complete-option-letter-spacing-inner: var(--perxis-auto-auto-complete-option-letter-spacing, 0);
  --perxis-auto-auto-complete-option-line-height-inner: var(--perxis-auto-auto-complete-option-line-height, 1.5);
  --perxis-auto-auto-complete-option-text-transform-inner: var(
    --perxis-auto-auto-complete-option-text-transform,
    none
  );
  /* End Option */
  /* Dropdown-item title suffix */
  --perxis-auto-auto-complete-title-suffix-color-inner: var(
    --perxis-auto-auto-complete-title-suffix-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  /* Dropdown-item title details */
  --perxis-auto-auto-complete-details-font-size-inner: var(
    --perxis-auto-auto-complete-details-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-auto-complete-details-line-height-inner: var(--perxis-auto-auto-complete-details-line-height, 1);
  --perxis-auto-auto-complete-details-weight-inner: var(
    --perxis-auto-auto-complete-details-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-auto-complete-details-color-inner: var(
    --perxis-auto-auto-complete-details-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* Border */
  --perxis-auto-auto-complete-dropdown-border-color-inner: var(
    --perxis-auto-auto-complete-dropdown-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-auto-complete-dropdown-active-border-color-inner: var(
    --perxis-auto-auto-complete-dropdown-active-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-auto-complete-dropdown-filled-border-color-inner: var(
    --perxis-auto-auto-complete-dropdown-filled-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-auto-complete-dropdown-border-inner: var(
    --perxis-auto-auto-complete-dropdown-border,
    2px solid var(--perxis-auto-auto-complete-dropdown-border-color-inner)
  );
  --perxis-auto-auto-complete-dropdown-active-border-inner: var(
    --perxis-auto-auto-complete-dropdown-active-border,
    2px solid var(--perxis-auto-auto-complete-dropdown-active-border-color-inner)
  );
  --perxis-auto-auto-complete-dropdown-border-radius-inner: var(
    --perxis-auto-auto-complete-dropdown-border-radius,
    0 0 8px 8px
  );
  /* End Border */
  border: var(--perxis-auto-auto-complete-dropdown-border-inner);
  border-radius: var(--perxis-auto-auto-complete-dropdown-border-radius-inner);
  background-color: var(--perxis-auto-auto-complete-dropdown-background-color-inner);
  border-top: none;
  padding: 0;
  top: 100% !important;
  bottom: auto !important;
}
.perxis-auto-1_16_13-auto-complete__dropdown .ant-5_17_0-select-item-option {
  padding: var(--perxis-auto-auto-complete-option-padding-inner);
  color: var(--perxis-auto-auto-complete-option-color-inner);
  font-family: var(--perxis-auto-auto-complete-option-font-family-inner);
  font-size: var(--perxis-auto-auto-complete-option-font-size-inner);
  font-variant-numeric: var(--perxis-auto-auto-complete-option-font-variant-numeric-inner);
  line-height: var(--perxis-auto-auto-complete-option-line-height-inner);
  font-weight: var(--perxis-auto-auto-complete-option-font-weight-inner);
  text-transform: var(--perxis-auto-auto-complete-option-text-transform-inner);
  letter-spacing: var(--perxis-auto-auto-complete-option-letter-spacing-inner);
}
.perxis-auto-1_16_13-auto-complete__dropdown .ant-5_17_0-select-item-option-active {
  color: var(--perxis-auto-auto-complete-option-active-color-inner);
}
.perxis-auto-1_16_13-auto-complete__title-suffix {
  color: var(--perxis-auto-auto-complete-title-suffix-color-inner);
}
.perxis-auto-1_16_13-auto-complete__details {
  color: var(--perxis-auto-auto-complete-details-color-inner);
  font-size: var(--perxis-auto-auto-complete-details-font-size-inner);
  font-weight: var(--perxis-auto-auto-complete-details-weight-inner);
  line-height: var(--perxis-auto-auto-complete-details-line-height-inner);
}
.perxis-auto-1_16_13-auto-complete__match {
  --perxis-auto-search-match-font-weight-inner: var(--perxis-auto-search-match-font-weight, 700);
  font-weight: var(--perxis-auto-search-match-font-weight-inner);
  background-color: transparent;
  color: inherit;
}
.perxis-auto-1_16_13-auto-complete__input {
  --perxis-auto-input-placeholder-font-size: var(--perxis-auto-root-typography-small-font-size-xxl-inner);
  --perxis-auto-input-placeholder-line-height: 1;
  --perxis-auto-input-padding: var(--perxis-auto-auto-complete-input-padding-inner);
  --perxis-auto-input-border-width: 0;
  --perxis-auto-input-height: var(--perxis-auto-auto-complete-height-inner);
}
.perxis-auto-1_16_13-auto-complete__icons-divider {
  width: var(--perxis-auto-auto-complete-divider-width-inner);
  height: 100%;
  background-color: var(--perxis-auto-auto-complete-divider-background-color-inner);
}
.perxis-auto-1_16_13-auto-complete__icons-wrapper {
  --perxis-auto-auto-complete-icons-wrapper-height-inner: var(
    --perxis-auto-auto-complete-icons-wrapper-height,
    max(
      var(--perxis-auto-auto-complete-discard-icon-size-inner),
      var(--perxis-auto-auto-complete-search-icon-size-inner),
      18px
    )
  );
  --perxis-auto-auto-complete-icons-gap-inner: var(--perxis-auto-auto-complete-icons-gap, 12px);
  display: flex;
  gap: var(--perxis-auto-auto-complete-icons-gap-inner);
  height: var(--perxis-auto-auto-complete-icons-wrapper-height-inner);
  border: 0;
  background: transparent;
  cursor: initial;
}
.perxis-auto-1_16_13-auto-complete__discard-icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-auto-complete-discard-icon-size-inner, 15px);
  color: var(--perxis-auto-auto-complete-discard-icon-color-inner);
}
.perxis-auto-1_16_13-auto-complete__discard-icon:hover {
  color: var(--perxis-auto-auto-complete-discard-hover-icon-color-inner);
}
.perxis-auto-1_16_13-auto-complete__search-icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-auto-complete-search-icon-size-inner, 15px);
  color: var(--perxis-auto-auto-complete-search-icon-color-inner);
}
.perxis-auto-1_16_13-auto-complete__search-icon:hover {
  color: var(--perxis-auto-auto-complete-search-hover-icon-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
